import { Card, Grid, Tab, Tabs } from "@mui/material";
import { wpAdminListSearch } from "atom/wp/wpAdminListSearch";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useResetRecoilState } from "recoil";
import DashboardNavbar from "../../../examples/Navbars/DashboardNavbar";
import AdminWPListTable from "./list/AdminWpAllDocList";
import AdminToggleMenu from "./list/AdminToggleMenu";
import WpBasicSetting from "./wpBasicsetting/WpBasicSetting";
import UserSettingPanel from "./wpBasicsetting/UserSettingPanel";
import AdditionalPointSetting from "./additional/AdditionalPointSetting";



const AdminWPpage = () => {
    // 탭 상태 (기존 AdminVacation 형식과 동일)
    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <> 
        <DashboardLayout>
            <DashboardNavbar/>
            <Card
                sx={{
                backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.8),
                boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
                position: "relative",
                mt: 2,
                mx: 0,
                py: 2,
                px: 2,
                }}
                >
                <Grid container spacing={3} alignItems="center" display="flex" justifyContent="space-between">
                    <Grid item>
                        <SoftBox height="100%" mt={0.5} lineHeight={1}>
                            <SoftTypography variant="h5" fontWeight="bold">
                                복지포인트 관리자 
                            </SoftTypography>
                        </SoftBox>
                    </Grid>
                </Grid>
            </Card>

            {/* 탭 네비게이션 (기존 형식) */}
            <SoftBox mt={2} mb={2}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Tabs value={tabValue} onChange={handleChange} centered sx={{ bgcolor: '#ccd6e6' }}>
                            <Tab label="사용자 복지포인트 신청 목록" />
                            <Tab label="복지포인트 설정" />
                            <Tab label="추가 복지포인트 설정" />
                        </Tabs>
                    </Grid>

                    <Grid item xs={12}>
                        {/* 탭 내용 */}
                        {tabValue === 0 && (
                            <SoftBox mt={1} mb={1}>
                                <Card>
                                    <AdminToggleMenu />
                                </Card>
                            </SoftBox>
                        )}
                        {tabValue === 1 && (
                            <>
                                <SoftBox mt={1} mb={1}>
                                    <Card>
                                        <WpBasicSetting />
                                    </Card>
                                </SoftBox>
                                <SoftBox mt={1} mb={1}>
                                    <Card>
                                        <UserSettingPanel />
                                    </Card>
                                </SoftBox>
                            </>
                        )}
                        {tabValue === 2 && (
                            <>
                                <SoftBox mt={1} mb={1}>
                                    <Card>
                                        <AdditionalPointSetting />
                                    </Card>
                                </SoftBox>
                            </>
                        )}
                    </Grid>
                </Grid>
            </SoftBox>

            {/* <SoftBox mt={2} mb={2}>
				<Card>
					<AdminWPListTable />
        		</Card>
			</SoftBox> */}
            
        </DashboardLayout>
        </>
    );
    
}

export default AdminWPpage